export enum EditAddressDialogActionType {
  Create,
  Edit,
}
